<template>
  <div class="forget_container">
    <div class="forget_box">
      <h2>Retrieve password</h2>

      <div class="verticalLine"></div>
      <h4 class="title1">The process of retrieving the password</h4>
      <el-steps :active="active1" align-center style="margin-top: 150px;background:#DCDFE6;height: 70px;padding-top: 40px">
        <el-step title="Confirm the account"></el-step>
        <el-step title="To reset your password"></el-step>
        <el-step title="Reset the success"></el-step>
      </el-steps>

      <div  v-if="active1 === 1">
        <el-form ref="forgetFormRef" :model="forgetForm" label-width="100px" :rules="forgetFormRules" class="forget_form" >
          <!--    用户名-->
          <el-form-item prop="email"  label="email">
            <el-input v-model="forgetForm.email" placeholder="Please enter your email address"></el-input>
          </el-form-item>
          <el-form-item prop="code"  label="code">
            <el-col :span="13"><el-input v-model="forgetForm.code" placeholder="Please enter the verification code"></el-input></el-col>
            <el-col :offset="2" :span="6">
              <el-button size="medium" type="warning" plain @click="sendMessage" v-if="isSend" >{{sendmsg}}</el-button>
              <el-button size="medium" type="warning" plain v-if="!isSend" >{{sendmsg}}</el-button>
            </el-col>
          </el-form-item>
          <el-form-item class="btns">
            <el-button style=" height: 37px;margin-left: -20px" type="info" @click="toLogin">cancel</el-button>
            <el-button class="button1" type="primary" @click="toNext1">next step</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div  v-if="active1 === 2">
        <el-form ref="forgetFormRef" :model="forgetForm" label-width="100px" :rules="forgetFormRules" class="forget_form" >
          <!--    用户名-->
          <el-form-item prop="password"  label="The new password"  >
            <el-input v-model="forgetForm.password" type="password" placeholder="The new password"></el-input>
          </el-form-item>
          <!--    用户名-->
          <el-form-item style="margin-top: 50px" prop="checkPass"  label="Confirm password">
            <el-input v-model="forgetForm.checkPass" type="password" placeholder="Confirm password"></el-input>
          </el-form-item>
          <el-form-item class="btns">
            <el-button style=" height: 37px;" type="info" @click="toLogin">cancel</el-button>
            <el-button class="button1" type="primary" @click="toNext2">next step</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div  v-if="active1 === 3">
        <el-result icon="success" title="Your password has been changed successfully" subTitle="Please go to the login page">
          <template slot="extra">
            <el-button type="primary" size="medium" @click="toLogin">Click to</el-button>
          </template>
        </el-result>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data () {
    //验证两次密码是否一致
    const pass = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,}$/
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Please enter a new password'));
      }else if(!pass.test(value)){
        callback(new Error('Enter 8 to 20 characters, including at least three combinations of uppercase and lowercase letters, digits, and special characters'))
      } else {
        if (this.forgetForm.checkPass !== '') {
          this.$refs.forgetFormRef.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please confirm the password'));
      } else if (value !== this.forgetForm.password) {
        callback(new Error('The two input passwords are inconsistent!'));
      } else {
        callback();
      }
    };

    //验证码不能为空
    const yzm = /^\d{6}$/
    var checkYzm = (rule, value, callback) => {
      if (!value) {
        callback(new Error('The verification code cannot be empty'));
      }else if(!yzm.test(value)){
        callback(new Error('Please enter a 6-digit verification code'))
      }else{
        callback()
      }
    };
    //验证邮箱
    var checkEmail = (rule, value, callback) => {
      // 验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
      if (value === '') {
        callback(new Error('Please enter email address'));
      } else {
        if (regEmail.test(value)) {
          // 合法的邮箱
          callback()
        } else {
          callback(new Error('Please enter a valid email address'))
        }

      }
    }
    //手机号验证
    var checkPhone= (rule, value, callback) =>{
      const regPhone = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (!value) {
        callback(new Error('Please enter your mobile number'));
      }else {
        if (regPhone.test(value)) {
          // 合法的手机号
          callback()
        } else {
          callback(new Error('Please enter a valid cell phone number'))
        }
      }
    };
    return {
      active1:1,
      //发送验证码
      isSend: true,
      sendmsg: 'Get verification code',
      forgetForm: {
        email:'',
        password:'',
        checkPass:'',
        code:'',
        confId:''
      },
      forgetFormRules: {
        // 验证手机号
        email: [
          { validator: checkEmail,trigger: 'blur',required: true}
        ],
        //验证码验证
        code: [
          { validator: checkYzm, trigger: 'blur',required: true}
        ],
        // 验证密码
        password: [
          { validator: validatePass,trigger: 'blur', required: true }
        ],
        //  验证密码是否合法
        checkPass: [
          { validator: validatePass2, trigger: 'blur',required: true }
        ],
      }
    }
  },
  mounted() {
    this.forgetForm.confId = window.sessionStorage.getItem("id")
  },
  methods: {
    toLogin(){
      let id = window.sessionStorage.getItem("id")
      this.$router.push('/login?='+id)
      // this.$router.push('/home')
      this.active1 =1
    },
    //判断验证码是否正确
    toNext1(){
      this.$refs.forgetFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('api/missPwd/check',{email:this.forgetForm.email,code:this.forgetForm.code,confId:this.forgetForm.confId})
        console.log(res);
        if(res.code === 200) {
          this.active1++
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    //重置密码
    toNext2(){
      this.$refs.forgetFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('api/resetPwdInUser', this.forgetForm)
        // console.log(this.forgetForm);
        console.log(res);
        if(res.code === 200) {
          this.$message.success('Reset the success')
          this.$refs.forgetFormRef.resetFields();
          this.active1++
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    //发送验证码按钮
    sendMessage(){
      this.$refs.forgetFormRef.validateField('email',async valid => {
        if (valid) return
        const { data: res } = await this.$http.post('api/missPwd/emailVerify/'+this.forgetForm.confId+'/'+this.forgetForm.email)
        // console.log(res);
        if (res.code !== 200) return this.$message.error(res.msg)
        this.$message.success(res.msg)
        this.isSend = false;
        let timer = 60;
        this.sendmsg = timer + "s";
        this.timeFun = setInterval(() => {
          --timer;
          this.sendmsg = timer + "s";
          if (timer === 0) {
            this.isSend = true;
            this.sendmsg = "重新发送";
            clearInterval(this.timeFun);
          }
        }, 1000);
      })
    },
  },
}
</script>

<style lang="less" scoped>
.forget_container{
  background-color: #35597b;
  position: relative;
  height: 100%;
}
.forget_box{
  height: 650px;
  width: 1000px;
  //background-color: #fff;
  background-color: #E9EEF3;
  border-radius: 3px;
  border: 1px solid rgba(255,255,255,.3);
  -moz-box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  -webkit-box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  position: absolute;
  left: 50%;
  top: 5%;
  transform: translate(-50%);
}
.btns{
  width: 100%;
  padding: 20px 25px;
  .button1{
    height: 37px;
    margin-left: 50px;
  }
}
h2{
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.forget_form{
  width: 400px;
  height: 100%;
  margin: 60px auto;
}
.verticalLine{
  width: 5px;
  height: 35px;
  display: flex;
  float: left;
  margin-left: 15px;
  margin-top: 100px;
  background-color:#409EFF;
}
.title1{
  float: left;
  display: flex;
  margin: 102px 0 20px 25px;
  color: #409EFF;
}
</style>

